import { graphql } from 'react-relay';
import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { getConfluenceContentAri } from '@confluence/content-types-utils/entry-points/getConfluenceContentAri.ts';

type PreloadAutohighlightsArgs = {
	contentId: string;
	cloudId: string;
	activationId: string;
	contentType: string;
};
// This function is only used for SSR and is being called in the preloadViewPageRoute.ts file. This preloads data that is then fetched from the cache during SSR in the contextual reading aids package -> PageContentRendererFabric component.
export const preloadAutohighlights = ({
	contentId,
	cloudId,
	activationId,
	contentType,
}: PreloadAutohighlightsArgs) => {
	const entityAri = getConfluenceContentAri({
		siteId: cloudId,
		resourceType: contentType,
		resourceId: contentId,
		activationId: '',
	});
	const workspaceId = getConfluenceContentAri({
		siteId: cloudId,
		resourceType: 'workspace',
		resourceId: activationId,
		activationId: '',
	});
	return queryAgg({
		query: preloadAutohighlightsQuery,
		variables: {
			workspaceId,
			entityAri,
		},
	});
};
export const preloadAutohighlightsQuery = graphql`
	query preloadAutohighlightsQuery(
		$entityAri: String!
		$workspaceId: String!
		$jiraReporterAccountId: String
		$jiraAssigneeAccountId: String
		$inputText: KnowledgeDiscoveryKeyPhraseInputText
	) {
		knowledgeDiscovery {
			keyPhrases(
				entityAri: $entityAri
				workspaceId: $workspaceId
				jiraReporterAccountId: $jiraReporterAccountId
				jiraAssigneeAccountId: $jiraAssigneeAccountId
				inputText: $inputText
			) @optIn(to: "KnowledgeDiscovery Get Key Phrases") {
				__typename
				... on KnowledgeDiscoveryKeyPhraseConnection {
					nodes {
						... on KnowledgeDiscoveryKeyPhrase {
							keyPhrase
							category
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
